export const TQ_URL_PREFIX = '/tq';
export const SPM_URL_PREFIX = '/spm';

/**
 * Planning Cycles List routes
 */
export const ROUTE_PLANNING_CYCLES = `${TQ_URL_PREFIX}/planning_cycles`;
export const ROUTE_PLANNING_CYCLES_APPROVALS = `${ROUTE_PLANNING_CYCLES}/approvals`;
export const ROUTE_PLANNING_CYCLES_WORKFLOWS = `${ROUTE_PLANNING_CYCLES}/workflows`;

/**
 * SPM Plan routes (START)
 */
export const ROUTE_SPM_PLAN_VIEW = `${TQ_URL_PREFIX}/plans/:planningCycleId${SPM_URL_PREFIX}`;
export const ROUTE_SPM_PLAN_DETAIL_VIEW = `${ROUTE_SPM_PLAN_VIEW}/scenarios/:scenarioId`;

// Approval base route - used when reviewing an approval
// In approval mode, only model routes are accessible (Overview and Data are hidden)
export const ROUTE_SPM_PLAN_APPROVAL = `${ROUTE_SPM_PLAN_DETAIL_VIEW}/approvals/:approvalId`;

// Overview Tab routes
export const ROUTE_SPM_PLAN_OVERVIEW_TAB = `${ROUTE_SPM_PLAN_DETAIL_VIEW}/overview/:overviewPath`;

// Model Tab routes (normal mode)
export const ROUTE_SPM_PLAN_QUOTA_MODEL = `${ROUTE_SPM_PLAN_DETAIL_VIEW}/quota/:spmModelId/:subPath?`;
export const ROUTE_SPM_PLAN_CAPACITY_MODEL = `${ROUTE_SPM_PLAN_DETAIL_VIEW}/capacity/:spmModelId/:subPath?`;
export const ROUTE_SPM_PLAN_TERRITORIES = `${ROUTE_SPM_PLAN_DETAIL_VIEW}/territories/:spmModelId/:subPath?`;

// Territories Geocarving route (no approval mode - carving not available during approvals)
export const ROUTE_SPM_PLAN_TERRITORIES_CARVING = `${ROUTE_SPM_PLAN_DETAIL_VIEW}/territories/:spmModelId/carving`;

// Model Tab routes (approval mode)
export const ROUTE_SPM_PLAN_QUOTA_MODEL_APPROVAL = `${ROUTE_SPM_PLAN_APPROVAL}/quota/:spmModelId/:subPath?`;
export const ROUTE_SPM_PLAN_CAPACITY_MODEL_APPROVAL = `${ROUTE_SPM_PLAN_APPROVAL}/capacity/:spmModelId/:subPath?`;
export const ROUTE_SPM_PLAN_TERRITORIES_APPROVAL = `${ROUTE_SPM_PLAN_APPROVAL}/territories/:spmModelId/:subPath?`;

// Data Tab routes (START)
export const ROUTE_SPM_PLAN_DATA_TAB = `${ROUTE_SPM_PLAN_DETAIL_VIEW}/data/:dataPath`;
export const ROUTE_SPM_PLAN_DATA_PROPERTY = `${ROUTE_SPM_PLAN_DETAIL_VIEW}/data/property/:propertyId`;
export const ROUTE_SPM_PLAN_DATA_ACCOUNTS = `${ROUTE_SPM_PLAN_DETAIL_VIEW}/data/accounts`;
export const ROUTE_SPM_PLAN_DATA_ACCOUNTS_EDIT = `${ROUTE_SPM_PLAN_DATA_ACCOUNTS}/edit`;
export const ROUTE_SPM_NEW_DATA_FROM_RESOURCE = `${ROUTE_SPM_PLAN_DETAIL_VIEW}/data/new-from-resource`;

export const ROUTE_SPM_MODEL_SUDO = `${TQ_URL_PREFIX}/sudo/:planningCycleId${SPM_URL_PREFIX}/scenarios/:scenarioId/:modelName/:spmModelId/:subPath?`;

/**
 * Enum for SPM main panel view identifiers
 * Used to identify which main section of the SPM interface is currently active
 */
export enum SPMMainView {
  OVERVIEW = 'overview',
  CAPACITY = 'capacity',
  QUOTA = 'quota',
  TERRITORIES = 'territories',
  DATA = 'data',
  DATA_ACCOUNTS = 'data-accounts',
  DATA_PROPERTY = 'data-property',
}

export const SPM_DESTINATIONS = {
  ROUTE_SPM_PLAN_VIEW,
  ROUTE_SPM_PLAN_DETAIL_VIEW,
  ROUTE_SPM_PLAN_APPROVAL,
  ROUTE_SPM_PLAN_OVERVIEW_TAB,
  ROUTE_SPM_PLAN_QUOTA_MODEL,
  ROUTE_SPM_PLAN_CAPACITY_MODEL,
  ROUTE_SPM_PLAN_TERRITORIES,
  ROUTE_SPM_PLAN_QUOTA_MODEL_APPROVAL,
  ROUTE_SPM_PLAN_CAPACITY_MODEL_APPROVAL,
  ROUTE_SPM_PLAN_TERRITORIES_APPROVAL,
  ROUTE_SPM_PLAN_DATA_TAB,
  ROUTE_SPM_PLAN_DATA_ACCOUNTS,
  ROUTE_SPM_PLAN_DATA_ACCOUNTS_EDIT,
  ROUTE_SPM_NEW_DATA_FROM_RESOURCE,
};

/**
 * Plan routes (END)
 */

export type PlanScenarioParams = {
  planningCycleId: string;
  scenarioId: string;
};

export type PlanScenarioModelParams = {
  planningCycleId: string;
  scenarioId: string;
  spmModelId: string;
};

export type PlanScenarioApprovalParams = PlanScenarioParams & {
  approvalId: string;
};

export type PlanScenarioApprovalModelParams = PlanScenarioApprovalParams & {
  spmModelId: string;
};
